(function () {
    'use strict';

    angular
        .module('franchisee-portal.components')
        .controller('HomeController', HomeController);

    /** @ngInject */
    function HomeController($rootScope, $timeout, $window, NewsService, HelperService, AuthenticationService) {
        const vm = this;

        vm.loggedUserData = null;
        vm.latestNews = null;
        vm.readNews = readNews;
        vm.ignoreNews = ignoreNews;

        $rootScope.fullScreenApp = false;
        $rootScope.showIntroduction = false;

        // Inicialização
        init();

        function init() {
            vm.loggedUserData = AuthenticationService.getUserData();

            // Verifica se o modal deve ser exibido
            if (shouldShowModal()) {
                fetchLatestNews();
            }
        }

        // Busca a última notícia
        function fetchLatestNews() {
            NewsService
                .getAllByParameters({
                    PerPage: 1, // Apenas a última news
                    Skip: 0,
                    Active: true,
                    OrderBy: 'RegistrationDate',
                    OrderDescending: true
                })
                .then(success => {
                    if (success.Informative && success.Informative.length > 0) {
                        vm.latestNews = success.Informative[0];
                        showModal();
                    }
                }, error => {
                    HelperService.errorCallback(error);
                });
        }

        // Exibe o modal
        function showModal() {
            if (vm.latestNews) {
                $timeout(() => {
                    $('#modalAviso').modal('show');
                }, 500);
            }
        }

        // Abre a notícia ao clicar em "Ler"
        function readNews(news) {
            if (news && news.Id) {
                var url = '/news/internal/' + news.Id;
                window.location.href = url; // Redireciona para o link na mesma aba
            }
            hideModalUntilFriday(); // Marca o modal como visualizado
        }


        // Ignora a notícia
        function ignoreNews() {
            hideModalUntilFriday(); // Marca o modal como visualizado
        }

        // Marca o modal como visualizado até sexta-feira às 17h
        function hideModalUntilFriday() {
            const now = new Date();
            const nextFriday = getNextFridayAtFivePM();
            localStorage.setItem('lastModalDismiss', nextFriday.toISOString());
            $('#modalAviso').modal('hide'); // Fecha o modal
        }

        // Retorna a próxima sexta-feira às 17h
        function getNextFridayAtFivePM() {
            const now = new Date();
            const nextFriday = new Date();

            // Define o próximo dia da semana como sexta-feira (5)
            nextFriday.setDate(now.getDate() + ((5 - now.getDay() + 7) % 7 || 7));

            // Define a hora como 17:00
            nextFriday.setHours(17, 0, 0, 0);

            return nextFriday;
        }

        // Verifica se o modal deve ser exibido
        function shouldShowModal() {
            const lastDismiss = localStorage.getItem('lastModalDismiss');
            if (!lastDismiss) return true; // Mostra o modal se nunca foi visualizado

            const now = new Date();
            const dismissUntil = new Date(lastDismiss);

            // Mostra o modal se já passou da última sexta-feira às 17h
            return now >= dismissUntil;
        }
    }
}());
